"use client";
import { Box, Divider, HStack, Text } from "@chakra-ui/react";
import { Modal } from "../modal";
import { CopyLinkButton } from "./copy-link-button";

export interface ShareLinkModalProps {
  title: string;
  subtitle: string;
  link: string;
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

export const ShareLinkModal = (props: ShareLinkModalProps) => {
  const { title, subtitle, isOpen, setOpen, link } = props;

  const onClose = () => setOpen(false);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <Box>
        <Text fontWeight="extrabold" align="center">
          {title}
        </Text>
        <Text fontWeight="medium" align="center">
          {subtitle}
        </Text>
      </Box>
      <Divider borderColor="black" my="-20px" />
      <HStack align="center">
        <CopyLinkButton link={link} onClick={onClose} />
      </HStack>
    </Modal>
  );
};
